<template>
  <div style="width:100%; text-align: right;">
    <v-btn
      color="primary"
      @click="handleExport"
    >
      <v-icon>mdi-microsoft-excel</v-icon>
      Export
    </v-btn>
  </div>
</template>
<script>
//import XLSX from 'xlsx'
import * as XLSX from 'xlsx/xlsx.mjs'
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleExport () {
      let data = XLSX.utils.json_to_sheet(this.data)
      const workbook = XLSX.utils.book_new()
      const filename = 'cliks'
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
  },
}
</script>
